import Toast, { notify } from './toast';

export { notify };
export default Toast;
